<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        Saldo
      </p>
    </header>
    <div class="card-content">
      <p class="title">
        {{ data.amount | money }}
      </p>
      <p class="subtitle">atualizado em {{ data.updatedAt | dateTime }}</p>
    </div>
  </div>
</template>

<script>
import "../../filters/money";
import "../../filters/dateTime";
import reports from "../../services/reports";

export default {
  props: {
    msg: String
  },
  data() {
    return {
      title: "Saldo",
      data: {},
      isLoading: false
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      reports.getBalance().then(data => {
        this.isLoading = false;
        this.data = data;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
